import React, { useRef, useMemo, useState, useEffect } from 'react';
import Filter from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/StoreRank/components/Filter';
import StoreRankDetailsCore from '@/pages/intelligence/pages/TopCharts/components/StoreRankDetailsCore';
import EChartDownloadModal from '@/pages/intelligence/components/ExportTable/components/EChartDownloadModal';
import DownloadSettingModal from '@/pages/intelligence/components/ExportTable/components/DownloadSettingModal';
import MultiTypeDownloadBtn from '@/pages/intelligence/pages/TopCharts/components/MultiTypeDownloadBtn';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import useInitialTopChartsName from '@/pages/intelligence/pages/StoreRanks/components/StoreRankMoreCore/hooks/useInitialTopChartsName';
import useStoreRankDetailsCoreUI from '@/pages/intelligence/pages/TopCharts/components/StoreRankDetailsCore/hooks/useStoreRankDetailsCoreUI';
import useDownload from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/StoreRank/hooks/useDownload';
import { fetchStoreRanksDetailsData } from '@/pages/intelligence/services/storeRank';
import { fetchStoreRankDetailsCountriesRanksPlus } from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/StoreRank/services';
import { getMobileDataSourceInfo } from '@/pages/intelligence/utils/getDataSourceInfo';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { updateURLSearchParams } from '@intelligence/utils/commonUtils';
import { analysisPlatformTopInfo } from '@/pages/intelligence/_config/storeRank/utils';
import {
  getMarketsValue,
  handleResData,
  getInitialFetchParamsDetailStoreRank,
} from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/StoreRank/utils';
import { getSortedStorankSources } from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/StoreRank/utils/metadata';
import { DOWNLOAD_ECHART_TYPE } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
import {
  MOBILE_SOURCES,
  MOBILE_STORE_RANK_TOPS_NAMES_MAPPING,
} from '@/pages/intelligence/_config/storeRank/config';
import '@/pages/intelligence/assets/scss/TopCharts/MobileGames/components/StoreRank.scss';
import { STATIC_FILTER_CONFIGS } from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/StoreRank/components/Filter/config';
import type { IBaseProps, IGameType } from '@/pages/intelligence/types/common';
import type { IEChartOption } from '@/pages/intelligence/types/echart';
import type {
  IStoreRankDetailsDataFetchParams,
  IStoreRankDetailsTablesSourceData,
  IStoreRankDetailsCountriesRanks,
  IStoreRankDetailsResData,
} from '@/pages/intelligence/types/storeRank';
import type { IStoreRankDetailsCoreInstance } from '@/pages/intelligence/pages/TopCharts/components/StoreRankDetailsCore/types';
import TipContext from '@home/components/TipContextComponents/TipContext';
import { useSelector } from 'umi';
import useEarliestTime from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/utilsTmp/useEarliestTime';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import { getFirstWeekSinceReleaseDates, isFirstWeekSinceReleaseShortcut } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/utils';

const DETAILS_MOBILE_SOURCES = [
  ...MOBILE_SOURCES,
  'googleplay top new free',
  'googleplay top new paid',
];

const DOWNLOAD_SOURCE_TYPES_MAP: {
  [key: string]: string;
} = {
  appstore: 'app_store',
  googleplay: 'google_play',
};

const DEFAULT_FETCH_PARAMS: IStoreRankDetailsDataFetchParams = {
  entity_type: 'mobile',
  app_ids: [],
  source: ['appstore top free'],
  region_type: 'market',
  regions: ['global'],
  granularity: 'daily',
  start_date: '',
  end_date: '',
};

interface IStoreRankDetailsProps extends IBaseProps {
  entityType: IGameType;
  gameId: string;
  appIds?: any;
  appIdListAll?: any[];
  isBasicLoading: boolean;
  basicInfo: object | any;
  countryList: any[];
}

const InputList = [
  STATIC_FILTER_CONFIGS.SEGMENT_STORERANK,
  STATIC_FILTER_CONFIGS.RANGE_TIME_SELECT_FILTER,
  STATIC_FILTER_CONFIGS.COUNTRY_REGION_FILTER,
  STATIC_FILTER_CONFIGS.SINGLE_SOURCE_SELECT_FILTER,
];

const MarketCount: React.FC<IStoreRankDetailsProps> = (props) => {
  const {
    entityType,
    gameId,
    appIds: appIdsProps,
    isBasicLoading,
    basicInfo = {},
    countryList = [],
    activeSegment,
    setActiveSegment,
    setDestroyed,
    filterLoading,
    regionOptions,
  } = props;

  // console.log('MarketCountMarketCount', props);

  const { formatMessage } = useIntlExtend();

  // const filterState = useSelector((state: any) => state?.[FILTER_EXTEND_NAMESPACE]);
  // const { isOperateDetail, detailFilterExtend } = useFilterExtend({});
  const { isOperateDetail, detailFilterExtend, setDetailFilterExtend, resetDetailFilterExtend } =
    useFilterExtend({});

  const initialTopChartsName = useInitialTopChartsName(DETAILS_MOBILE_SOURCES);
  // console.log('detailFilterExtend---222222222', detailFilterExtend);
  const appIds = useMemo(() => {
    if (!Array.isArray(appIdsProps)) return [];
    return appIdsProps?.filter((id) => id?.length > 0);
  }, [appIdsProps]);
  const defaultFetchParams = { ...DEFAULT_FETCH_PARAMS, app_ids: appIds };
  let initialFetchParams = getInitialFetchParamsDetailStoreRank(
    isOperateDetail,
    detailFilterExtend,
    defaultFetchParams,
    activeSegment,
  );
  // let initialFetchParams = {};
  initialFetchParams = { ...initialFetchParams, source: [initialTopChartsName] };
  // 数据源，也就是商店
  const [sources, setSources] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fetchParams, setFetchParams] =
    useState<IStoreRankDetailsDataFetchParams>(initialFetchParams);

  const topchartsState = useSelector((state: any) => state?.[DBI_TOPCHARTS] || {});
  const isSectionalRank = fetchParams?.regions?.length > 1;
  const title = isSectionalRank
    ? (formatMessage({ id: 'dbi_store_rank_visualis_card_title_multipe' }) as string)
    : (formatMessage({ id: 'dbi_store_rank_visualis_card_title_single' }) as string);
  const { platform, top } = analysisPlatformTopInfo(fetchParams?.source?.[0]);
  const topLocaleKey = MOBILE_STORE_RANK_TOPS_NAMES_MAPPING[top];
  const topLocaleText = topLocaleKey ? (formatMessage({ id: topLocaleKey }) as string) : top;
  const downloadSourceType = DOWNLOAD_SOURCE_TYPES_MAP[platform];
  const storeRankDetailsCore = useRef<IStoreRankDetailsCoreInstance>(null);
  const [echartOptionForDownload, setEChartOptionForDownload] = useState<IEChartOption>({});
  const [sourceData, setSourceData] = useState<IStoreRankDetailsResData[]>([]);

  const platformInfo = getMobileDataSourceInfo(platform);
  const { visualisOption, tablesOption } = useStoreRankDetailsCoreUI({
    isLoading,
    isSectionalRank,
    isExpandable: true,
    visualisHelpperOptionConfig: {
      // isShowYAxisName: true,
      // yAxisName: isSectionalRank ? formatMessage({ id: 'dbi_count' }) : formatMessage({ id: 'dbi_rank' }),
      tooltipHeaderLeftTitle: topLocaleText,
      tooltipHeaderLeftIcon: platformInfo?.icon,
      rankDimensionsNameFormatter: (dimension: string) => {
        const platformInfo = getMobileDataSourceInfo(platform);
        const platformName = platformInfo?.name;
        const platformTopInfo = platformName && top ? [platformName, topLocaleText].join('_') : '';
        // 只选了单国家时，图例展示榜单名
        if (fetchParams?.regions?.length === 1) {
          return platformTopInfo || '';
        }
        return platformTopInfo && dimension ? `${platformTopInfo} ${dimension}` : '';
      },
    },
    tablesHelpperOptionConfig: {},
    data: sourceData,
  });
  const { earliestPeriod, updateEarliestDateData, baseReleaseTimeValue } = useEarliestTime({
    entityType,
    basicInfo,
    topchartsState,
  });

  const {
    isDownloadEChart,
    isDownloadData,
    isVisible: isDownloadVisible,
    setIsVisible: setIsDownloadVisible,
    isLoading: isDownloadLoading,
    setIsLoading: setIsDownloadLoading,
    onClick: handleDownloadClick,
    onCancel: handleDownloadCancel,
  } = useDownload();

  const handleDownloadClickPlus = (type: string) => {
    if (type === DOWNLOAD_ECHART_TYPE) {
      const option = storeRankDetailsCore.current?.getEChartOption();
      if (option) {
        setEChartOptionForDownload(option);
      }
    }
    handleDownloadClick(type);
  };

  const updateStoreRankDetailsData = async (
    fetchParamsPayload: Partial<IStoreRankDetailsDataFetchParams>,
  ) => {
    try {
      setIsLoading(true);
      const sourcePayload = fetchParamsPayload?.source;
      const regionsPayload = fetchParamsPayload?.regions;
      const sourceTmp = sourcePayload?.length ? sourcePayload : fetchParams?.source;
      const regionsTmp = regionsPayload?.length ? regionsPayload : fetchParams?.regions;
      let fetchParamsTmp = {
        ...fetchParams,
        unified_id: basicInfo?.id,
        source: sourceTmp,
        // regions: regionsTmp,
        regions: getMarketsValue(regionsTmp, regionOptions),
        start_date: fetchParamsPayload?.start_date || fetchParams?.start_date,
        end_date: fetchParamsPayload?.end_date || fetchParams?.end_date,
      } as any;
      const res = await fetchStoreRanksDetailsData(fetchParamsTmp);
      const req = res?.req || {};

      let firstWeekSinceReleaseDates: string[] = [];
      if (isFirstWeekSinceReleaseShortcut(topchartsState?.selectedTimeShortcutType)) {
        firstWeekSinceReleaseDates = getFirstWeekSinceReleaseDates({
          dateType: fetchParamsTmp?.granularity,
          startDate: fetchParamsTmp?.start_date,
          endDate: fetchParamsTmp?.end_date,
          releaseDate: baseReleaseTimeValue,
        });
      }
      const responseData = Array.isArray(res?.data) ? res.data : [];
      const responseDataMap = new Map(responseData.map((item: any) => [item?.date, item]));
      const sourceDataForChart = firstWeekSinceReleaseDates.length
        ? firstWeekSinceReleaseDates.map(
            (date) => responseDataMap.get(date) || { date, metric: [] },
          )
        : responseData;

      const storeRankDetailsCoreResData = handleResData(sourceDataForChart, {
        isSectionalRank: fetchParamsTmp?.regions?.length > 1,
      });
      setSourceData(storeRankDetailsCoreResData);
      // 初始化时从接口返回中获取开始和结束时间，并回填组件
      fetchParamsTmp = {
        ...fetchParamsTmp,
        start_date: req?.start_date,
        end_date: req?.end_date,
      };
      setFetchParams(fetchParamsTmp);
      // 更新最早有数据时间
      updateEarliestDateData({
        entity_type: fetchParamsTmp.entity_type,
        data_sources: fetchParamsTmp.source,
        app_ids: fetchParamsTmp.app_ids,
        metric: ['rank'],
        unified_id: fetchParamsTmp?.unified_id,
        region_type: fetchParamsTmp.region_type,
        regions: fetchParamsTmp.regions,
        dateType: fetchParamsTmp.granularity,
      });
    } finally {
      setIsLoading(false);
    }
  };

  // 分段排名时，国家排名子表格 获取数据的方法
  const fetchCountriesRankData = async (
    params: IStoreRankDetailsTablesSourceData,
  ): Promise<IStoreRankDetailsCountriesRanks[]> =>
    fetchStoreRankDetailsCountriesRanksPlus({
      ...fetchParams,
      appIds,
      source: fetchParams?.source,
      regions: fetchParams?.regions,
      endDate: params?.date || '',
      entityType: 'mobile',
    });

  const handleConfirm = (
    payload: Partial<IStoreRankDetailsDataFetchParams>,
    segmentValue: string,
  ) => {
    const fetchParamsTmp = {
      ...fetchParams,
      ...payload,
      // regions: getMarketsValue(payload.regions, regionOptions),
    };

    // console.log('payload', payload);

    if (segmentValue === 'market') {
      updateStoreRankDetailsData(fetchParamsTmp);
      setFetchParams(fetchParamsTmp);
      updateURLSearchParams({ source: fetchParamsTmp?.source?.[0] });
    }
  };

  const handleReset = () => {};

  useEffect(() => {
    if (isBasicLoading) return;
    if (filterLoading) return;
    if (activeSegment === 'market') {
      setSources(getSortedStorankSources(basicInfo?.source));
      updateStoreRankDetailsData(fetchParams);
    }
  }, [isBasicLoading, filterLoading]);

  return (
    <div className="dbi-mobile-games-storerank dbi-mobile-games-details-store-rank">
      <div className="dbi-statsfilter-warp">
        <div className="statsfilter-warp-left">
          <Filter
            regionsOptions={regionOptions}
            // regionsOptionsMap={regionsOptionsMap}
            sources={sources}
            source={fetchParams?.source?.[0]}
            granularity={fetchParams?.granularity}
            startDate={fetchParams?.start_date}
            endDate={fetchParams?.end_date}
            onConfirm={handleConfirm}
            onReset={handleReset}
            inputList={InputList}
            setActiveSegment={setActiveSegment}
            setDestroyed={setDestroyed}
            activeSegment={activeSegment}
            sinceReleaseTime={baseReleaseTimeValue}
            earliestDataTime={earliestPeriod}
          />
        </div>
        <div className="dbi-statsfilter-warp-right">
          <MultiTypeDownloadBtn onSelect={handleDownloadClickPlus} />
        </div>
      </div>

      <StoreRankDetailsCore
        ref={storeRankDetailsCore}
        isLoading={isLoading}
        gameId={gameId}
        title={
          appIds?.length > 1 ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {title}
              <TipContext
                className="tip-text-hd dbi_pc_store_rank_tips"
                tipText={formatMessage({ id: 'dbi_info_rank_trend_mobile_tip_desc' })}
              />
            </div>
          ) : (
            title
          )
        }
        countries={countryList}
        visualisOption={visualisOption}
        tablesOption={tablesOption}
        entityType={entityType}
        gameName={basicInfo?.name}
        gameCover={basicInfo?.cover}
        dateType={fetchParams?.granularity}
        startDate={fetchParams?.start_date}
        endDate={fetchParams?.end_date}
        selectedMode={fetchParams?.regions?.length === 1 ? 'single' : true}
        pageLogConfig={dbiPageLogMes.mobileGameDetailsStoreRank}
        fetchCountriesRankData={fetchCountriesRankData}
        isNewOpenTable={true}
      />

      {/* EChart下载弹窗 */}
      <EChartDownloadModal
        downloadLogConfigKey="mobileGameDetailsStoreRankDownloadEChart"
        echartDownloadtitle={title}
        echartDownloadOptions={echartOptionForDownload}
        echartLegends={visualisOption?.sourceDataDimensions}
        visible={isDownloadEChart && isDownloadVisible}
        onCancel={handleDownloadCancel}
      />
      {/* 数据表下载弹窗 */}
      <DownloadSettingModal
        entityType="mobile"
        businessType="mobile-details-store-rank"
        classModalName=""
        downloadModalSize="l"
        downloadTitleTips="You can choose the aggregated or separated methods to display the data with the current filter."
        downloadLogConfigKey="mobileGameDetailsStoreRankDownloadExcel"
        isDisableDataAmount={true}
        total={0}
        visible={isDownloadData && isDownloadVisible}
        setModalVisible={setIsDownloadVisible}
        loading={isDownloadLoading}
        setLoading={setIsDownloadLoading}
        tableParams={{
          entity_type: entityType,
          app_ids: appIds,
          // 下载数据表时，入参的数据源，根据选择的榜单确定数据源
          default_source_type: downloadSourceType ? [downloadSourceType] : [],
          // mobile游戏详情页store rank 只有日粒度数据，固定传daily
          date_type: fetchParams?.granularity,
          region_type: fetchParams?.region_type,
          regions: fetchParams?.regions,
          start_date: fetchParams?.start_date,
          end_date: fetchParams?.end_date,
        }}
        isShowMaxDownloadRowsTips={false}
        newStyleFileName={`${basicInfo?.name}_Store Rank`}
      />
    </div>
  );
};

export default MarketCount;
